import "./index.css";
import "./App.css";
import React from "react";
import { Switch, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import HaBookManager from "./components/HeresAmericaManager";
import IBC from "./components/IBC";
import AuthoringToolTwoPointZero from "./components/AuthoringToolTwoPointZero";
import Book from "./components/book_components/Book";
import BookList from "./components/BookList";
import BookCard from "./components/BookCard";
import CategoryList from "./components/category_components/CategoryList";
import DomainList from "./components/domain_components/DomainList";
import CreatorList from "./components/creator_components/CreatorList";
import MaterialAddBook from "./components/MaterialAddBook";
import ShowcaseList from "./components/showcase_components/ShowcaseList";
import LoginPage from "./components/auth_components/LoginPage";
import RestrictedComponent from "./components/RestrictedComponent";
import Navbar from "./components/Navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Logged in state
import Store from "./components/auth_components/state/Store";
import BookDetails from "./components/BookDetails";

function App() {
  return (
    <Store>
      <div>
        {/* Dark Spanning Navbar With Links to every page*/}
        <ToastContainer />

        <Navbar />
        {/* Container contains every page, switch determines which page is showing */}
        <div className="App">
          {/* ^ need to use this empty div for a fake margin because I have no idea what .scss file is dictating the style of things with those weird classes ^ -Cody */}
          <div style={{ height: "3rem" }} />
          <Switch>
            {/* <Route
            exact
            path={["/", "/books"]}
            render={(props) =>
              !needsLogin ? (
                // console.log("doesnt need login")
                // <Redirect to={{ pathname: "/login" }} />
                <BookList />
              ) : (
                // <BookList {...props} />
                <Redirect to={{ pathname: "/login" }} />
              )
            }
            // component={BookList}
          /> */}
            <RestrictedComponent
              exact
              path={["/", "/books"]}
              redirectPath={"/login"}
              component={BookList}
            />
            <RestrictedComponent
              path="/heres-america-manager"
              component={HaBookManager}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/smart-reach"
              component={IBC}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              exact
              path="/add"
              component={MaterialAddBook}
              add={true}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/books/:id"
              component={Book}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/bookcard"
              component={BookCard}
              redirectPath={"/login"}
            />
            {/* <Route path="/browse" component={BrowseByCategory} /> */}
            <RestrictedComponent
              path="/categories"
              component={CategoryList}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/domains"
              component={DomainList}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/creators"
              component={CreatorList}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/showcases"
              component={ShowcaseList}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/details"
              component={BookDetails}
              redirectPath={"/login"}
            />
            <RestrictedComponent
              path="/authoring-tool-2.0"
              component={AuthoringToolTwoPointZero}
              redirectPath={"/login"}
            />
            <Route path="/login" component={LoginPage} />
          </Switch>
        </div>
      </div>
    </Store>
  );
}

export default App;
